import { IHealthProfileGoal } from '@src/types/goal';

const pad = (value: number) => String(value).padStart(2, '0');

interface IBuildShopifyCheckoutAttributesOptions {
  isFreeTrial?: boolean;
  now?: Date;
}

export const buildShopifyCheckoutAttributes = (
  firstName: string | undefined,
  healthGoals: IHealthProfileGoal[] | undefined,
  options: IBuildShopifyCheckoutAttributesOptions = {}
) => {
  const { isFreeTrial = false, now = new Date() } = options;
  const attributes: Record<string, string> = {
    formulated_at: String(Math.floor(now.getTime() / 1000)),
    formulated_at_label: new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(now),
    date_created: `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()} ${pad(
      now.getHours()
    )}:${pad(now.getMinutes())}`,
  };

  if (isFreeTrial) {
    attributes.free_trial = 'true';
  }

  const sanitizedFirstName = firstName?.trim();
  if (sanitizedFirstName) {
    attributes.First_Name = sanitizedFirstName;
  }

  const selectedGoals = healthGoals?.filter(goal => goal.selected).slice(0, 3) || [];
  selectedGoals.forEach((goal, index) => {
    const goalNumber = index + 1;
    if (goal?.id) {
      attributes[`goal${goalNumber}_key`] = goal.id;
    }
    if (goal?.healthPillar) {
      attributes[`goal${goalNumber}_name`] = goal.healthPillar;
    }
  });

  return attributes;
};
